/*
 * @author Lemuel Raganas <lemuel.raganas@mediacorp.com.sg>
 **/

import DataApi from "@/libs/DataApi";
import MainStub from "@/libs/data-api-loader/MainStub";
import OnReady from "@/libs/data-api-loader/OnReady";
import GetDataApiOption from "@/libs/data-api/GetOption";
import OnRequestError from "@/libs/data-api-loader/OnRequestError";
import OnReadyHandler from "@/libs/data-api-loader/OnReadyHandler";
import OnRequestErrorHandler from "@/libs/data-api-loader/OnRequestErrorHandler";
import StatusAware from "@/libs/common/delegate/StatusAware";

export default class DataApiLoader {
  protected dataApi: DataApi;
  protected onReadyHandler: OnReadyHandler = new OnReadyHandler();
  protected onErrorHandler: OnRequestErrorHandler = new OnRequestErrorHandler();
  protected uid?: string;
  protected year?: number;
  protected statusAware?: StatusAware;

  constructor(options?: MainStub) {
    this.dataApi = options.dataApi;
    this.onErrorHandler.add(options.onError);
    this.onReadyHandler.add(options.onReady);

    if (options !== undefined) {
      this.uid = options.uid;
      this.year = options.year || undefined;
      this.statusAware = options.statusAware || undefined;
    }
  }

  public onReady(o: OnReady) {
    this.onReadyHandler.add(o);
    return this;
  }

  public onError(ore: OnRequestError) {
    this.onErrorHandler.add(ore);
    return this;
  }

  public load(name: string, options?: GetDataApiOption) {
    const that = this;

    if (!this.dataApi.hasApi(name)) {
      return this;
    }

    this.dataApi
      .get(name, options)
      .then((rs) => {
        if (this.onReadyHandler !== undefined) {
          this.onReadyHandler.handle(name, rs.data, that);
        }
      })
      .catch((rs) => {
        if (this.onErrorHandler !== undefined) {
          this.onErrorHandler.handle(name, {
            error: rs,
            reference: that,
          });
        }
      });

    return this;
  }
}
